/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { Injectable } from '@angular/core';
import { type BaseRequestOptionsArgs, type HttpResponse, HttpService } from '@dm/core';
import { type DnsService } from 'app/common/types/mo';
import { type Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class FileDnsServiceService {
    constructor(
        private httpService: HttpService,
    ) {}

    // 获取DNS
    getDnsServer(vstoreId?: string, options?: BaseRequestOptionsArgs): Observable<HttpResponse> {
        const rest = this.httpService.makeUrl('fileDnsServer.get');

        if (vstoreId) {
            rest.setParams({ vstoreId });
        }
        return this.httpService.get(rest, options);
    }

    // 设置DNS
    setDnsServer(params: DnsService, options?: BaseRequestOptionsArgs): Observable<HttpResponse> {
        const rest = this.httpService.makeUrl('fileDnsServer.put');
        return this.httpService.put(rest, params, options);
    }

    // 测试DNS
    testDnsServer(params: DnsService, options?: BaseRequestOptionsArgs): Observable<HttpResponse> {
        const rest = this.httpService.makeUrl('fileDnsServer.test');
        return this.httpService.put(rest, params, options);
    }
}

